export const techAndMeasures = {
  categories: {
    wastewater: 'Atık su',
    energy: 'Enerji',
    water: 'Su',
    energyAndWater: 'Enerji ve Su'
  },
  allProjects: {
    title: 'Tüm Projeler'
  },
  topProjects: {
    title: 'Ana Projeler'
  },
  quickWins: {
    title: 'Hızlı kazançlar'
  },
  measure: 'Ölçüm',
  type: 'Tür',
  category: 'Kategori',
  estimatedInvestment: 'Tahmini Yatırım Gideri',
  estimatedOperational: 'Tahmini İşletme Gideri',
  traditionalTechnologyDesc: 'Geleneksel Teknoloji Tanımı',
  mainBenefitsOfBestAvailableTechnology: 'En İyi Mevcut Teknolojinin Başlıca Faydaları',
  resourceReductionProposedTechnology: 'Önerilen Teknolojinin Geleneksel Teknolojiye Kıyasla Kaynak Azaltımı',
  bestAvailableTechnologyInfo: 'En İyi Mevcut Teknoloji Üreticileri Bilgileri',
  description: 'Açıklama',
  bestAvailableTechnologyDescription: 'En İyi Mevcut Teknoloji Tanımı',
  caseStudy: 'Vaka Çalışması',
  resourceReduction: 'Kaynak Azaltımı',
  limitations: 'Sınırlamalar',
  implementationDifficulty: 'Uygulama Zorluğu',
  potentialChemicalSuppliers: 'Potansiyel Kimyasal Tedarikçileri',
  avoidanceOfStandardizedWashOffAfterContinuousPrinting: 'Kontinü Baskıdan Sonra Standart Yıkamadan Kaçınma',
  optimizationOfExhaustDyeingMachineCapacity: 'Çektirme Boyama Makinesi Kapasitesinin Optimizasyonu',
  adequateProductionPlanning: 'Yeterli Üretim Planlaması',
  avoidanceOfBleachingInDarkShades: 'Koyu Renklerde Beyazlatmadan Kaçınma',
  centrifugationAfterGarmentDyeingWithReactiveDyes: 'Reaktif Boyalarla Giysi Boyandıktan Sonra Santrifüjleme',
  installationOfHandTriggersAtWaterHoses: 'Su Hortumlarına El Tetikleri Takılması',
  energyReduction: 'Enerji Azaltımı',
  caseStudyResReducCalc: 'Vaka Çalışması Kaynak Azaltımı',
  targetParameter: 'Hedef Parametre',
  otherMeasures: 'Diğer Önlemler',
  impactEnergy: 'Enerji Etkisi:',
  impactWater: 'Su Etkisi:',
  recommendations: 'Öneriler',
  filter: 'Filtre',
  etpType: 'ETP Türü',
  parameter: 'Parametre',
  expenditureInvestement: 'Yatırım',
  impact: 'Etki',
  orderby: 'Sıralama Ölçütü',
  noData: 'Seçilen filtrelerle eşleşen veri bulunmamaktadır',
  clearAll: 'Hepsini Temizle',
  clear: 'Temizle'
};
